import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { totalRowRatio, sumRoundedTotal } from '../../../../../react-table/helpers/rowTotals';

export function getSummaryTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id,
    mainReportId: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.id,
    requestParams: {
      mrdLocation: rowInfo.row['impc'], // eslint-disable-line
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.id,
    ],
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('IMPC', 'impc').withTotalHeader('Total', 'bg-total-grey'),
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Units', 'units').withTotalHeader(sumRoundedTotal, 'bg-total-grey'), getSummaryTabNavigationProps),
        new NonZeroNumberColumn('Registered receptacles', 'registeredReceptacles').withTotalHeader(sumRoundedTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('Attributed receptacles', 'attributedReceptacles').withTotalHeader(sumRoundedTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('Weight (kg) reg. rcpts', 'weightRegisteredReceptacles').withTotalHeader(sumRoundedTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('Weight (kg) attr. rcpts', 'weightAttributedReceptacles').withTotalHeader(sumRoundedTotal, 'bg-total-grey'),
        new NonZeroPercentageColumn('% Attr. rcpts', 'pctAttributedReceptacles').withTotalHeader(totalRowRatio(['attributedReceptacles', 'registeredReceptacles']), 'bg-total-grey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id,
        mainReportId: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.id,
        requestParams: {
          isTotal: true,
          mrdLocation: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
